/* eslint-disable react/no-unescaped-entities */
import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import "../styles/scss/Home.scss";
import { Link } from "react-router-dom";

export default class Home extends React.Component {
  render(): JSX.Element {
    return (
      <Container fluid id="home" className="mainContent">
        <Row className="landingDiv">
          <Col className="d-flex">
            <Container>
              <h1>{"JOSHUA YUEN"}</h1>
              <h4>
                {
                  "Self-learning software to solve problems I've made for myself."
                }
              </h4>
            </Container>
          </Col>
        </Row>
        <Row className="myWorkDiv">
          <Col>
            <Container>
              <h3>MY WORK</h3>
              <p>
                  I've always been interested in coming up with creative solutions to problems. A lot of the time these "problems" come from video games that I'm interested in (see <Link to="/projects#TundraHooks">TundraHooks</Link>, <Link to="/projects#GTA_Horse_Racing_Bot">GTA Horse Racing Bot</Link>, or <Link to="/projects#Auto_Lamp">Auto Lamp</Link>). Other times, my problems are more practical and have real value to being solved (see <Link to="/projects#SoundCloud_to_Spotify_Playlist_Converter">SoundCloud to Spotify Playlist Converter</Link> or <Link to="/projects#Samsung_Watch_WoL_App">Samsung Watch WoL App</Link>).
              </p>
            </Container>
          </Col>
        </Row>
      </Container>
    );
  }
}
